import React from 'react';
import { Button } from 'react-bootstrap';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Button
      className="theme-toggle"
      variant={isDarkMode ? 'light' : 'dark'}
      onClick={toggleTheme}
    >
      <i className={`fas fa-${isDarkMode ? 'sun' : 'moon'}`}></i>
    </Button>
  );
};

export default ThemeToggle;
